<template>
	<span v-text="item.title" :class="curr?'text-green':''"></span>
	<i class="icon icon-check float-right text-green fs-20 marginr20" v-if="curr"></i>
</template>

<script>
export default {
	props: {
		curr: {
			type: Boolean
			, default: false
		}
		, item: {
			type: Object
			, default: {}
		}
	}
};
</script>